import { render, staticRenderFns } from "./vue-multiselect.html?vue&type=template&id=9d19bbba&scoped=true&"
import script from "./vue-multiselect.js?vue&type=script&lang=js&"
export * from "./vue-multiselect.js?vue&type=script&lang=js&"
import style0 from "./vue-multiselect.scss?vue&type=style&index=0&id=9d19bbba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d19bbba",
  null
  
)

export default component.exports